export default {
    basket: {
        id: 0,
        customerId: 0,
        hasVat: true,
        itemPacks: []
    },
    loadingContent: false,
    loadingCredits: false,
    freeTransportLimit: null,
    user: null,
};
